import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.666 31.667h7.157c3.109 0 4.663 0 5.546-.652a3.333 3.333 0 0 0 1.341-2.391c.096-1.093-.715-2.42-2.336-5.072l-1.661-2.719m-21.496-3.158-3.592 5.877c-1.62 2.653-2.431 3.98-2.336 5.072a3.333 3.333 0 0 0 1.341 2.391c.883.652 2.437.652 5.546.652h2.99M28.148 15 24.55 9.113c-1.504-2.462-2.256-3.693-3.225-4.112a3.333 3.333 0 0 0-2.65 0c-.97.42-1.722 1.65-3.226 4.112l-1.7 2.782M30 8.333l-1.83 6.83-6.83-1.83M3.333 19.33l6.83-1.83 1.83 6.83m13.84 12.337-5-5 5-5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }